import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const SITE_URL =
  'https://www.mauriziopinkrosa.it/?utm_source=pwa_metronomo&utm_medium=app_button&utm_campaign=metronomo_back_link';

export const AuthorSignature = () => (
  <div data-testid="author-signature" className="relative mx-auto max-w-md rounded-2xl border border-pink-500/30 bg-gradient-to-br from-pink-500/10 via-pink-500/[0.04] to-transparent backdrop-blur-sm px-6 py-5 text-center shadow-[0_0_30px_rgba(236,72,153,0.15)]">
    <div className="text-[9px] uppercase tracking-[0.4em] text-white/35 mb-2">Made by</div>
    <div className="font-bebas text-3xl sm:text-4xl tracking-wide leading-none">
      Maurizio <span className="text-pink-400 italic">"Pink"</span> Rosa
    </div>
    <div className="text-[10px] uppercase tracking-[0.3em] text-white/45 mt-2">
      with <span className="text-pink-300">emergent</span>
    </div>
    <a
      data-testid="author-site-link"
      href={SITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="group mt-4 inline-flex items-center gap-2 rounded-full bg-pink-500 px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-black shadow-[0_0_20px_rgba(236,72,153,0.45)] transition-[transform,background-color,box-shadow] duration-200 hover:bg-pink-400 hover:shadow-[0_0_30px_rgba(236,72,153,0.7)] active:scale-95"
    >
      Scopri Maurizio Pink Rosa
      <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
    <div className="mt-4">
      <Link data-testid="author-info-link" to="/info" className="text-[10px] uppercase tracking-[0.3em] text-white/50 hover:text-pink-300 underline underline-offset-4">
        Informazioni e privacy
      </Link>
    </div>
  </div>
);
